class Loader {
  constructor(
    loaderEl
  ) {
    this.loaderEl = loaderEl;
  }

  toggle() {
    this.loaderEl.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  hide() {
    this.loaderEl.classList.add('hidden');
    document.body.style.overflow = '';
  }
}

export default Loader;
